// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"58276410","53":"3dd68dad","59":"772d4e06","62":"079255d6","63":"9ad7b7f5","142":"9e5d005b","145":"29da56ac","534":"e2818ed2","592":"8f87446b","852":"6eed7c85","861":"91b1b828","899":"77552601","919":"b0ef816f","929":"c820f897","951":"05506dd8"}[chunkId] + ".chunk.js";
};